/**
 * Portal
 * The ISC Portal is designed as an entrypoint for ISC to publish solutions to multiple cloud providers that are consumed by external users.  On this page, Swagger UI is already pre-authorised with your current JWT token and you can explore and try out APIs with your current user\'s credentials.  <code> !!! WARNING !!! Any command you issue from this page or using API calls will take an immediate effect on your deployments and data without any further confirmations. Please be very careful with POST and DELETE commands. </code>  If you want to use those APIs programmatically, you need to get JWT token first because it has a very limited expiration time.  There are multiple options to get JWT token from Amazon Cognito which our Cloud Portal use, the simplest one is to use curl and jq commands:  <code> TOKEN=$(curl -s \"https://cognito-idp.us-east-2.amazonaws.com/\" \\ -X POST \\ -d \'{\"AuthFlow\":\"USER_PASSWORD_AUTH\",\"ClientId\":\"5lif09dom0glg27o8ha6duu9bs\",\"AuthParameters\":{\"USERNAME\":\"<USERNAME>\",\"PASSWORD\":\"<PASSWORD>\"}}\' \\ -H \"content-type: application/x-amz-json-1.1\" \\ -H \"X-Amz-Target: AWSCognitoIdentityProviderService.InitiateAuth\" | jq -r \'.AuthenticationResult.IdToken\'  ) </code>  After you get the token, you can use it to authenticate with InterSystems Cloud Portal, for example:  <code> curl \'https://portal.live.isccloud.io/v3/api/deployments\' \\ -X \'GET\' \\ -H \'accept: application/json\' \\ -H \"Authorization: Bearer $TOKEN\" </code> 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: portal-dev@intersystems.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeploymentObjectResourceList { 
    apigatewayid?: string;
    apigatewayusageplanid?: string;
    awsfhirendpoint?: string;
    awsfhirhostname?: string;
    awsportalendpoint?: string;
    awsportalhostname?: string;
    cognitooauth2poolid?: string;
    cognitopoolid?: string;
    firewall_enabled?: string;
    firewallip?: string;
    irisamiversion?: string;
    irisarbeiterhostname?: string;
    irisarbeiterinstanceid?: string;
    irisarbeiterjdbc?: string;
    irisarbeiterjdbcdownload?: string;
    irisarbeiterprometheusurl?: string;
    irisarbeiterterminal?: string;
    irisarbeiterurl?: string;
    irisdatadisk?: string;
    irisfhirendpoint?: string;
    irisfhirhostname?: string;
    irisiamendpoint?: string;
    irisiamhostname?: string;
    irispassword?: string;
    irisportalendpoint?: string;
    irisprimaryhostname?: string;
    irisprimaryinstanceid?: string;
    irisprimaryjdbc?: string;
    irisprimaryjdbcdownload?: string;
    irisprimaryprometheusurl?: string;
    irisprimaryterminal?: string;
    irisprimaryurl?: string;
    irissecondaryhostname?: string;
    irissecondaryinstanceid?: string;
    irissecondaryjdbc?: string;
    irissecondaryjdbcdownload?: string;
    irissecondaryprometheusurl?: string;
    irissecondaryterminal?: string;
    irissecondaryurl?: string;
    irisuser?: string;
    iscswaggerurl?: string;
    keydownload?: string;
    mamamiversion?: string;
    maminstanceid?: string;
    natip?: string;
    nlbhostname?: string;
    notificationsubscriptionarn?: string;
    notificationsubscriptioneventstoactionsarn?: string;
    notificationtopic?: string;
    prometheusurl?: string;
    prometheusurltargets?: string;
    sftpconnectionurl?: string;
    sftpendpoint?: string;
    sftpserverid?: string;
    vpcid?: string;
    passwordreseturl?: string;
}

